<div *ngIf="loading" class="loading-overlay-spinner">
    <mat-spinner></mat-spinner>
</div>